import { axios } from "../../lib/axios";

export const DeleteCertificate = (certificateId: string) => {
    return axios.delete(`/certificate-exam/${certificateId}`)
        .then(response => response.data);
};

